/**
 * Hydratation paresseuse des onglets de max-featured-collection.
 *
 * Seul le premier onglet est rendu en dur par max-collection-tab.liquid ; les suivants sont
 * enfermés dans un <template>, dont le contenu est inerte — aucune image n'est téléchargée.
 * Ce script les en sort à leur première activation.
 *
 * Pourquoi pas simplement du CSS : masquer les panneaux ne suffit pas. Mesuré sur la home,
 * visibility:hidden, content-visibility:hidden et display:none laissent tous Chrome charger
 * les images lazy des panneaux masqués — privées de boîte de layout, il ne peut pas calculer
 * leur distance au viewport et les charge donc immédiatement. C'était 46 images au chargement
 * pour 14 visibles, soit 432 ko pour deux onglets que personne n'avait ouverts.
 *
 * Script CLASSIQUE (pas un module) : ré-exécuté à chaque balise qui le charge, d'où le garde
 * d'idempotence. La délégation sur `document` couvre du même coup toutes les instances de la
 * section, présentes comme futures (re-render de l'éditeur).
 */
(function () {
  if (window.__maxCollectionTabsInit) return;
  window.__maxCollectionTabsInit = true;

  function hydrate(panel) {
    if (!panel) return;

    var template = panel.querySelector('template.mct__lazy');
    if (!template) return;

    template.replaceWith(document.importNode(template.content, true));

    // max-splide.js n'observe que les .max-splide présents au chargement : on lui signale
    // le slider qui vient d'apparaître, sinon il resterait une simple liste non montée.
    if (typeof window.maxSplideMount === 'function') window.maxSplideMount(panel);
  }

  // Le radio coché commande le panneau de même rang — voir les :nth-of-type de la section.
  function panelForRadio(radio) {
    var root = radio.closest('.mct__inner');
    if (!root) return null;

    var radios = root.querySelectorAll('.mct__radio');
    var panels = root.querySelectorAll('.mct__panels > .mct__panel');
    return panels[Array.prototype.indexOf.call(radios, radio)] || null;
  }

  document.addEventListener('change', function (event) {
    var radio = event.target;
    if (!radio.classList || !radio.classList.contains('mct__radio')) return;
    hydrate(panelForRadio(radio));
  });

  // Le survol du libellé précède le clic de quelques dizaines de ms : on hydrate dès là, pour
  // que le panneau soit prêt quand l'onglet s'active. `pointerover` et non `pointerenter` :
  // seul le premier remonte, condition de la délégation.
  //
  // MAIS uniquement au survol souris/stylet. Sur tactile, muter le DOM au premier contact
  // (le pointerover du tap) fait avaler le clic par le navigateur (iOS notamment) : la case
  // radio n'était cochée qu'au 2e tap. En tactile, on laisse donc l'event `change` — déclenché
  // APRÈS que le tap a coché la case — faire l'hydratation, et un seul tap suffit.
  document.addEventListener('pointerover', function (event) {
    if (event.pointerType === 'touch') return;

    var label = event.target.closest ? event.target.closest('.mct__tab') : null;
    if (!label) return;

    var radio = document.getElementById(label.getAttribute('for'));
    if (radio) hydrate(panelForRadio(radio));
  });
})();
